import { RESET_INITIALISATION } from "../../../modules/savedItems/constants";
import { CLEAR_PERSISTENT_ERRORS } from "../../../modules/common/constants";

export const reinitialise = initialise => dispatch => {
  dispatch({ type: RESET_INITIALISATION });
  dispatch({ type: CLEAR_PERSISTENT_ERRORS });
  dispatch(initialise());
};
